import { render, staticRenderFns } from "./ShowAuditTrails.vue?vue&type=template&id=512c8579&scoped=true"
import script from "./ShowAuditTrails.vue?vue&type=script&lang=js"
export * from "./ShowAuditTrails.vue?vue&type=script&lang=js"
import style0 from "./ShowAuditTrails.vue?vue&type=style&index=0&id=512c8579&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c8579",
  null
  
)

export default component.exports